import { withAuthenticationRequired } from "src/hooks/useAuth";
import React from "react";
import { IRoute } from "src/Routes/RouteConfig";
import { Allowed } from "../Allowed/Allowed";

interface IProps {
  route: IRoute;
}

export const RouteWithAuth = (props: IProps) => {
  const { route } = props;

  const AllowedComponent = () => {
    return (
      <Allowed route={route}>
        <route.component />
      </Allowed>
    );
  };

  const AuthenticatedComponent = withAuthenticationRequired(AllowedComponent, {
    onRedirecting: () => <>redirecting</>,
  });

  return <AuthenticatedComponent />;
};
